import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { useState } from 'react';
import themes from '../../../themes';
import { accordionMock1, accordionMock2, fiftyFifty1, textCardMock1, textCardMock2, textCardMock3, textCardMock4, ImageGalleryDataVariationA, ImageGalleryDataVariationB, footerMock, topNavMock, bottomNavMock } from '../../../utils/themeDemoMockData';
import { mockData as bookMock } from '../../../components/molecules/Book/Book.mock';
import { mockData as blogListMock } from '../../../components/molecules/BlogList/BlogList.mock';
import { mockData2 as paginationMock } from '../../../components/molecules/Pagination/Pagination.mock';
import { jumpLinkDataA, paraText } from '../../../components/molecules/Jumplink/Jumplink.mock';
import { mockData as contactUsNvaMock } from '../../../components/molecules/ContactUsNva/ContactUsNva.mock';
import { mockData as contactUsMock } from '../../../components/molecules/ContactUs/ContactUs.mock';
import { reviewCard as reviewCardMock } from '../../../components/molecules/ReviewCard/ReviewCard.mock';
import Accordion from '../../../components/molecules/Accordion';
import Book from '../../../components/molecules/Book/Book';
import ContactUs from '../../../components/molecules/ContactUs/ContactUs';
import ContactUsNva from '../../../components/molecules/ContactUsNva/ContactUsNva';
import TextCard from '../../../components/molecules/TextCard';
import BlogList from '../../../components/molecules/BlogList';
import Carousel from '../../../components/molecules/Carousel';
import ImageGallery from '../../../components/molecules/ImageGallery';
import FiftyFiftyCard from '../../../components/molecules/FiftyFiftyCard';
import Footer from '../../../components/molecules/Footer';
import FooterNva from '../../../components/molecules/FooterNva/FooterNva';
import Jumplink from '../../../components/molecules/Jumplink/Jumplink';
import Pagination from '../../../components/molecules/Pagination/Pagination';
import Para from '../../../components/atoms/Para/Para';
import TopNav from '../../../components/molecules/Header/TopNav';
import BottomNav from '../../../components/molecules/Header/BottomNav';
import ReviewCard from '../../../components/molecules/ReviewCard/ReviewCard';
var Molecules = function Molecules(_ref) {
  var _themes$themeSelected, _theme$carousel, _theme$carousel2;
  var themeSelected = _ref.themeSelected;
  var theme = (_themes$themeSelected = themes[themeSelected]) !== null && _themes$themeSelected !== void 0 ? _themes$themeSelected : {};
  var _useState = useState(false),
    forceErrorEmailSending = _useState[0],
    setForceErrorEmailSending = _useState[1];
  var _useState2 = useState('variation-a'),
    footerVariation = _useState2[0],
    setFooterVariation = _useState2[1];
  var _useState3 = useState(null),
    footerFontColor = _useState3[0],
    setFooterFontColor = _useState3[1];
  var _useState4 = useState(false),
    forceSuccessMessage = _useState4[0],
    setForceSuccessMessage = _useState4[1];
  var _useState5 = useState(false),
    forceErrorMessage = _useState5[0],
    setForceErrorMessage = _useState5[1];
  return __jsx(React.Fragment, null, __jsx("h1", null, "Theme Selected: ", themeSelected !== '' ? themeSelected : 'No theme selected'), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", {
    style: {
      width: '100%',
      maxWidth: 600
    }
  }, __jsx("h3", null, "Accordion"), __jsx("h4", null, "Font Color: Dark"), __jsx(Accordion, {
    accordionData: accordionMock1
  }), __jsx("br", null), __jsx("h4", null, "Font Color: Light"), __jsx(Accordion, {
    accordionData: accordionMock2
  })), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Blog List"), __jsx(BlogList, blogListMock)), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Book"), __jsx("button", {
    onClick: function onClick() {
      return setForceErrorEmailSending(true);
    }
  }, "Force Error Email Sending")), __jsx(Book, _extends({}, bookMock, {
    forceErrorEmailSending: forceErrorEmailSending
  })), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", {
    style: {
      width: '100%'
    }
  }, __jsx("h3", null, "TextCard"), __jsx("h4", null, "isAlreadyWrapped: false"), __jsx(TextCard, textCardMock1), __jsx("br", null), __jsx("h4", null, "isAlreadyWrapped: true"), __jsx(TextCard, textCardMock2), __jsx("br", null), __jsx("h4", null, "fontColor: Light - isHero: true - variation a"), __jsx("div", {
    className: "card-rich-text",
    style: {
      position: 'relative',
      height: '40rem',
      width: '100%',
      background: '#555'
    }
  }, __jsx(TextCard, textCardMock3)), __jsx("br", null), __jsx("h4", null, "fontColor: Dark - isHero: true - variation b"), __jsx("div", {
    style: {
      position: 'relative',
      height: '40rem',
      width: '100%',
      background: '#eee'
    }
  }, __jsx(TextCard, textCardMock4))), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    style: {
      paddingBottom: 40
    }
  }, __jsx("div", null, __jsx("h3", null, "Carousel"), __jsx(Carousel, {
    slidesToShow: 1,
    prevArrow: (_theme$carousel = theme.carousel) === null || _theme$carousel === void 0 ? void 0 : _theme$carousel.iconPrev(),
    nextArrow: (_theme$carousel2 = theme.carousel) === null || _theme$carousel2 === void 0 ? void 0 : _theme$carousel2.iconNext()
  }, __jsx("div", null, __jsx("div", {
    style: {
      height: 250,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, __jsx("h4", null, "SLIDE 1"))), __jsx("div", null, __jsx("div", {
    style: {
      height: 250,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, __jsx("h4", null, "SLIDE 2"))), __jsx("div", null, __jsx("div", {
    style: {
      height: 250,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, __jsx("h4", null, "SLIDE 3"))), __jsx("div", null, __jsx("div", {
    style: {
      height: 250,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, __jsx("h4", null, "SLIDE 4"))), __jsx("div", null, __jsx("div", {
    style: {
      height: 250,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, __jsx("h4", null, "SLIDE 5"))))), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Contact Us NVA - Success Message"), __jsx("button", {
    onClick: function onClick() {
      return setForceSuccessMessage(true);
    }
  }, "Force Success Message"), __jsx("br", null)), __jsx(FooterNva, {
    isfooterWithoutForm: false,
    logoImage: '',
    contactUsObject: '',
    addressObject: '',
    hoursOfOperationObject: '',
    mapImage: '',
    primaryLinksObject: '',
    utilityLinksObject: '',
    socialIconsData: '',
    contactUsNvaObject: {
      submitUrl: 'globalFooterProps.formUrl',
      successfulSubmissionMessage: 'Form submission successful',
      reCaptchaKey: 'this.props.reCaptchaKey'
    },
    showSuccessMessage: forceSuccessMessage
  }), __jsx("br", null), __jsx("div", null, __jsx("h3", null, "Contact Us NVA - Error Message"), __jsx("button", {
    onClick: function onClick() {
      return setForceErrorMessage(true);
    }
  }, "Force Error Message")), __jsx(FooterNva, {
    isfooterWithoutForm: false,
    logoImage: '',
    contactUsObject: '',
    addressObject: '',
    hoursOfOperationObject: '',
    mapImage: '',
    primaryLinksObject: '',
    utilityLinksObject: '',
    socialIconsData: '',
    contactUsNvaObject: {
      submitUrl: 'globalFooterProps.formUrl',
      successfulSubmissionMessage: 'Form submission successful',
      reCaptchaKey: 'this.props.reCaptchaKey'
    },
    showErrorMessage: forceErrorMessage
  }), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", {
    style: {
      width: '100%'
    }
  }, __jsx("h3", null, "50-50 Card"), __jsx(FiftyFiftyCard, _extends({}, fiftyFifty1, {
    styleType: "fiftyFifty",
    backgroundTheme: "Light",
    fontColor: "Dark"
  })), __jsx(FiftyFiftyCard, _extends({}, fiftyFifty1, {
    styleType: "fiftyFifty",
    backgroundTheme: "Dark",
    fontColor: "Light"
  }))), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", {
    style: {
      width: '100%'
    }
  }, __jsx("h3", null, "Footer"), __jsx("label", null, "Variation:", __jsx("select", {
    style: {
      marginLeft: 4
    },
    name: "footer-variation",
    id: "footer-variation",
    onChange: function onChange(event) {
      return setFooterVariation(event.target.value);
    },
    value: footerVariation
  }, __jsx("option", {
    value: ""
  }, "None"), __jsx("option", {
    value: "Variation-A"
  }, "Variation-A"), __jsx("option", {
    value: "Variation-B"
  }, "Variation-B"), __jsx("option", {
    value: "Mini-Footer"
  }, "Mini-Footer"), __jsx("option", {
    value: "Multi-location-footer"
  }, "Multi-location-footer"))), __jsx("label", {
    style: {
      marginLeft: 16
    }
  }, "Font Color:", __jsx("select", {
    style: {
      marginLeft: 4
    },
    name: "footer-font-color",
    id: "footer-font-color",
    onChange: function onChange(event) {
      return setFooterFontColor(event.target.value);
    },
    value: footerFontColor
  }, __jsx("option", {
    value: ""
  }, "None"), __jsx("option", {
    value: "Dark"
  }, "Dark"), __jsx("option", {
    value: "Light"
  }, "Light"))), __jsx(Footer, _extends({}, footerMock, {
    variation: footerVariation,
    globalFooterProps: {
      fontColor: footerFontColor
    }
  })))), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Form"), __jsx(Book, bookMock)), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Contact Us"), __jsx(ContactUs, {
    contactUsData: contactUsMock
  })), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Contact Us Nva"), __jsx(ContactUsNva, {
    contactUsData: contactUsNvaMock
  })), __jsx("div", null)), __jsx("hr", null), __jsx("section", null, __jsx("div", null, __jsx("h3", null, "Image Gallery"), __jsx(ImageGallery, _extends({}, ImageGalleryDataVariationA, {
    theme: theme
  })), __jsx(ImageGallery, _extends({}, ImageGalleryDataVariationB, {
    theme: theme
  }))), __jsx("div", null)), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Jumplink"), __jsx(Jumplink, jumpLinkDataA), __jsx(Para, {
    id: "section-doctors"
  }, paraText), __jsx(Para, {
    id: "section-team"
  }, paraText)), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", {
    style: {
      paddingRight: 60
    }
  }, __jsx("h3", null, "Header"), __jsx(TopNav, topNavMock), __jsx("br", null), __jsx(BottomNav, bottomNavMock)), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Pagination"), __jsx(Pagination, paginationMock)), __jsx("div", null)), __jsx("hr", null), __jsx("section", {
    className: "theme-section"
  }, __jsx("div", null, __jsx("h3", null, "Review Card"), __jsx(ReviewCard, reviewCardMock)), __jsx("div", null)), __jsx("hr", null));
};
export default Molecules;